<template>
  <tr class="panel-row" v-click-outside="validateAmount">
    <td class="index">

      <div class="index-invalid" v-if="panelInvalid">
        <font-awesome-icon icon="exclamation-triangle" class="font-awesome-icon invalid-panel"/>
      </div>

      <template v-else>
        {{ panel.id }}
      </template>
    </td>
    <td class="length">
      <input
        :id="'length-' + panel.id"
        ref="length"
        v-model="panel.length"
        v-on:keydown.left.prevent="upElement('reference')"
        v-on:keydown.up.prevent="upElement('length')"
        v-on:keydown.down.prevent="downElement('length')"
        v-on:keydown.right.prevent="rightElement('width')"
        v-on:keydown.enter.prevent="rightElement('width')"
        v-on:blur="validateRow(); validateNumber('length')"
        :class="{'is-invalid': lengthInvalid === true}"
        type="text"
        class="form-control"
        min="0"
        placeholder="mm"
      >
      <b-tooltip :show="lengthInvalid" id="lengthTooltip" ref="lengthTooltip" :target="() => $refs['length']" variant="danger" placement="bottom" triggers="manual">{{ lengthMessage }}</b-tooltip>
    </td>
    <td class="width">
      <input
        :id="'width-' + panel.id"
        ref="width"
        v-model="panel.width"
        v-on:keydown.left.prevent="leftElement('length')"
        v-on:keydown.up.prevent="upElement('width')"
        v-on:keydown.down.prevent="downElement('width')"
        v-on:keydown.right.prevent="rightElement('amount')"
        v-on:keydown.enter.prevent="rightElement('amount')"
        v-on:blur="validateRow(); validateNumber('width')"
        :class="{'is-invalid': widthInvalid === true}"
        type="text"
        class="form-control"
        min="0"
        placeholder="mm"
      >
      <b-tooltip :show="widthInvalid" id="widthTooltip" ref="widthTooltip" :target="() => $refs['width']" variant="danger" placement="bottom" triggers="manual">{{ widthMessage }}</b-tooltip>
    </td>
    <td class="amount">
      <input
        :id="'amount-' + panel.id"
        ref="amount"
        v-model="panel.amount"
        v-on:keydown.left.prevent="leftElement('width')"
        v-on:keydown.up.prevent="upElement('amount')"
        v-on:keydown.down.prevent="downElement('amount')"
        v-on:keydown.right.prevent="rightElement('l1')"
        v-on:keydown.enter.prevent="rightElement('l1')"
        :class="{'is-invalid': amountInvalid === true}"
        v-on:blur="validateRow()"
        onwheel="this.blur()"
        type="number"
        class="form-control"
        min="0"
      >
      <b-tooltip :show="amountInvalid" id="amountTooltip" ref="amountTooltip" :target="() => $refs['amount']" variant="danger" placement="bottom" triggers="manual">{{ amountMessage }}</b-tooltip>
    </td>
    <td class="checkbox l1">
      <input
        :id="'finish-l1-' + panel.id"
        ref="l1"
        v-model="panel.l1"
        v-on:keydown.left.prevent="leftElement('amount')"
        v-on:keydown.up.prevent="upElement('l1')"
        v-on:keydown.down.prevent="downElement('l1')"
        v-on:keydown.right.prevent="rightElement('l2')"
        v-on:keydown.enter.prevent="rightElement('l2')"
        type="checkbox"
        class="checkbox-side"
        :class="{'is-invalid': finishField === 'l1'}"
        @change="changeFinish('l1')"
      />
      <label :for="'finish-l1-' + panel.id" :id="'label-l1-' + panel.id" ref="l1Label"></label>
      <b-tooltip :if="finishField==='l1'" id="l1Tooltip" ref="l1Tooltip" :target="() => $refs['l1Label']" variant="danger" placement="bottom" triggers="manual">{{ finishMessage }}</b-tooltip>
    </td>
    <td class="checkbox l2">
      <input
        :id="'finish-l2-' + panel.id"
        ref="l2"
        v-model="panel.l2"
        v-on:keydown.left.prevent="leftElement('l1')"
        v-on:keydown.up.prevent="upElement('l2')"
        v-on:keydown.down.prevent="downElement('l2')"
        v-on:keydown.right.prevent="rightElement('b1')"
        v-on:keydown.enter.prevent="rightElement('b1')"
        type="checkbox"
        class="checkbox-side"
        :class="{'is-invalid': finishField === 'l2'}"
        @change="changeFinish('l2')"
      />
      <label :for="'finish-l2-' + panel.id" :id="'label-l2-' + panel.id" ref="l2Label"></label>
      <b-tooltip :if="finishField==='l2'" id="l2Tooltip" ref="l2Tooltip" :target="() => $refs['l2Label']" variant="danger" placement="bottom" triggers="manual">{{ finishMessage }}</b-tooltip>
    </td>
    <td class="checkbox b1">
      <input
        :id="'finish-b1-' + panel.id"
        ref="b1"
        v-model="panel.b1"
        v-on:keydown.left.prevent="leftElement('l2')"
        v-on:keydown.up.prevent="upElement('b1')"
        v-on:keydown.down.prevent="downElement('b1')"
        v-on:keydown.right.prevent="rightElement('b2')"
        v-on:keydown.enter.prevent="rightElement('b2')"
        type="checkbox"
        class="checkbox-side"
        :class="{'is-invalid': finishField === 'b1'}"
        @change="changeFinish('b1')"
      />
      <label :for="'finish-b1-' + panel.id" :id="'label-b1-' + panel.id" ref="b1Label"></label>
      <b-tooltip :if="finishField==='b1'" id="b1Tooltip" ref="b1Tooltip" :target="() => $refs['b1Label']" variant="danger" placement="bottom" triggers="manual">{{ finishMessage }}</b-tooltip>
    </td>
    <td class="checkbox b2">
      <input
        :id="'finish-b2-' + panel.id"
        ref="b2"
        v-model="panel.b2"
        v-on:keydown.left.prevent="leftElement('b1')"
        v-on:keydown.up.prevent="upElement('b2')"
        v-on:keydown.down.prevent="downElement('b2')"
        v-on:keydown.right.prevent="rightElement('reference')"
        v-on:keydown.enter.prevent="rightElement('reference')"
        type="checkbox"
        class="checkbox-side"
        :class="{'is-invalid': finishField === 'b2'}"
        @change="changeFinish('b2')"
      />
      <label :for="'finish-b2-' + panel.id" :id="'label-b2-' + panel.id" ref="b2Label"></label>
      <b-tooltip :if="finishField==='b2'" id="b2Tooltip" ref="b2Tooltip" :target="() => $refs['b2Label']" variant="danger" placement="bottom" triggers="manual">{{ finishMessage }}</b-tooltip>
    </td>
    <td class="reference">
      <input
        ref="reference"
        v-model="panel.reference"
        v-on:keydown.left.prevent="leftElement('b2')"
        v-on:keydown.up.prevent="upElement('reference')"
        v-on:keydown.down.prevent="downElement('reference')"
        v-on:keydown.right.prevent="downElement('length')"
        v-on:keydown.tab.prevent="downElement('length')"
        v-on:keydown.enter.prevent="downElement('length')"
        type="text"
        class="form-control reference"
        maxlength="30"
      >
    </td>
    <td class="actions">
      <template>
        <img src="images/icon-add-row.svg" :id="'copy-row-' + panel.id" ref="copy-row" class="font-awesome-icon action copy-row svg-inline--fa fa-w-18" @click="insert(panel)"/>
        <b-tooltip :target="() => $refs['copy-row']">Regel invoegen</b-tooltip>
        <font-awesome-icon :id="'trash-row-' + panel.id" ref="trash-row" class="font-awesome-icon action trash-row" @click="trashPanel(panel)" icon="trash-alt"/>
        <b-tooltip :target="() => $refs['trash-row']">Regel verwijderen</b-tooltip>
      </template>
    </td>
  </tr>
</template>

<script>
  import { REMOVE_PANEL, MUTATE_PANELS, SAVE_ORDER_LOCAL_STORAGE, MUTATE_CALCULATING_STATUS } from '../../../store/types'
  import vClickOutside from 'v-click-outside'
  import { panelValidation } from '../../../mixins/panel-validation'
  import { EventBus } from '../../../bus'

  export default {
    props: ['panel'],
    data() {
      return {
        width: null,
        widthInvalid: false,
        widthMessage: null,
        widthHasFinish: false,
        length: null,
        lengthInvalid: false,
        lengthMessage: null,
        lenghtHasFinish: false,
        amount: null,
        amountInvalid: false,
        amountMessage: null,
        finishField: false,
        finishMessage: null
      }
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [panelValidation],
    computed: {
      panels() {
        return !this.$store.getters.panels ? [] : this.$store.getters.panels
      },
      panelInvalid() {
        return this.widthInvalid === true || this.lengthInvalid === true || this.amountInvalid === true || this.finishField !== false
      },
      cart() {
        return !this.$store.getters.cart ? null : this.$store.getters.cart
      }
    },
    watch: {
      'panel.length': {
        handler(newVal, oldVal) {
          newVal = !newVal ? null : this.convertToNumber(newVal)
          this.length = newVal
          this.panel.length = this.length
          // this.validateRow()
          if (newVal !== oldVal) {
            this.resetCalculateStatus()
          }
          this.saveCart()
        }
      },
      'panel.width': {
        handler(newVal, oldVal) {
          this.width = !newVal ? null : this.convertToNumber(newVal)
          this.panel.width = this.width
          // this.validateRow()
          if (newVal !== oldVal) {
            this.resetCalculateStatus()
          }
          this.saveCart()
        }
      },
      'panel.amount': {
        handler(newVal, oldVal) {
          this.amount = !newVal ? null : newVal
          // this.validateRow()
          if (newVal !== oldVal) {
            this.resetCalculateStatus()
          }
          this.saveCart()
        }
      },
      'panel.reference': {
        handler(newVal, oldVal) {
          this.reference = !newVal ? null : newVal
          this.saveCart()
        }
      }
    },
    methods: {
      // Managing panels
      copy(panel) {
        let panelToCopy = this.panels.find((x) => {
          return x.id === panel.id
        })

        if (panelToCopy) {
          let newPanel = JSON.parse(JSON.stringify(panel))
          newPanel.id = this.panels.length + 1
          this.panels.push(newPanel)
        }
      },
      insert(panel) {
        if (panel.valid) {
          let newPanel = { id: panel.id + 1, length: null, width: null, amount: null, l1: false, l2: false, b1: false, b2: false, reference: null, valid: null }

          // create new array & insert the selected panel
          let newpanels = [...this.panels]
          newpanels.splice(panel.id, 0, newPanel)
          newpanels.map(function(x, i) {
            x.id = i + 1
          })
          this.$store.commit(MUTATE_PANELS, newpanels)
        }
      },
      trashPanel(panel) {
        if (panel.length || panel.width || panel.amount || panel.l1 || panel.l2 || panel.b1 || panel.b2) {
          this.resetCalculateStatus()
        }
        this.$store.dispatch(REMOVE_PANEL, panel)
      },
      saveCart() {
        if (this.panel.valid) {
          this.$store.dispatch(SAVE_ORDER_LOCAL_STORAGE, this.cart)
        }
      },
      resetCalculateStatus() {
        if (this.panel.valid === true) {
          this.$store.commit(MUTATE_CALCULATING_STATUS, null)
        }
      },
      // Validation
      validateRow() {
        this.validateFinish('l1')
        // this.validateFormat()     // will be called after validateFinish
      },
      validateAmount() {
        // Validate amount when clicking outside
        if (this.panel.width !== null && this.panel.length !== null && this.panel.amount === null) {
          this.amountInvalid = true
          this.amountMessage = 'Er is geen aantal ingevuld'

          this.$nextTick(function() {
            this.$root.$emit('bv::show::tooltip', 'amount-' + this.panel.id)
          })

          this.isValid()
        } else {
          this.amountInvalid = false
          this.amountMessage = null
        }
      },
      validateFormat() {
        // Validate panel format
        let validationResult = this.validatePanelRow(parseFloat(this.length), parseFloat(this.width), parseInt(this.amount), this.lenghtHasFinish, this.widthHasFinish)
        if (validationResult === null) {
          // Reset
          this.lengthInvalid = false
          this.lengthMessage = null
          this.widthInvalid = false
          this.widthMessage = null
        } else {
          if (validationResult[0] === 'length') {
            this.lengthInvalid = true
            this.lengthMessage = validationResult[1]
            this.widthInvalid = false
            this.widthMessage = null
          } else if (validationResult[0] === 'width') {
            this.lengthInvalid = false
            this.lengthMessage = null
            this.widthInvalid = true
            this.widthMessage = validationResult[1]
          }
          this.$nextTick(function() {
            this.$root.$emit('bv::show::tooltip', validationResult[0] + '-' + this.panel.id)
          })
        }
        // Reset the amount validation
        if (this.amount !== null) {
          this.amountInvalid = false
          this.amountMessage = null
        }
        this.isValid()
      },
      convertToNumber(value) {
        let val = '' + value
        val = val.replace(',', '.').replace(/[^\d.]/g, '')
        if (val.slice(-1) === '.') {
          return val
        }
        return Math.floor(parseFloat(val) * 10) / 10
      },
      validateNumber(field) {
        // remove the '.' if it is the last char
        let val = '' + this.panel[field]
        val = val.replace(',', '.').replace(/[^\d.]/g, '')
        this.panel[field] = Math.floor(parseFloat(val) * 10) / 10
      },
      rightElement(target) {
        this.$refs[target].focus()
      },
      leftElement(target) {
        this.$refs[target].focus()
      },
      upElement(target) {
        this.$emit('upElement', target, this.panel)
      },
      downElement(target) {
        this.$emit('downElement', target, this.panel)
      },
      changeFinish(el) {
        this.resetCalculateStatus()
        this.validateFinish(el)
      },
      validateFinish(el) {
        this.setHasFinish()

        this.$root.$emit('bv::hide::tooltip')

        // If there is some finish selected (NOTE: No finish available = false, No finish selected = 0)
        let finish = !this.$store.getters.materialFinish ? false : this.$store.getters.materialFinish
        if ((finish === false || finish.id === 0) && (this.lenghtHasFinish || this.widthHasFinish)) {
          // reset messages from other boxes and re-attach to new selectbox...
          let field = this.getSelectedFinish(el)
          this.finishField = field
          this.finishMessage = finish === false || finish.code !== 'np' ? 'Er is geen kantafwerking gekozen' : 'Kantafwerking is niet mogelijk'
          this.$nextTick(function() {
            this.$root.$emit('bv::show::tooltip', 'label-' + field + '-' + this.panel.id)
          })
        } else {
          this.finishField = false
          this.finishMessage = null

          // validate other fields
          this.validateFormat()
        }
        this.isValid()
        this.saveCart()
      },
      setHasFinish() {
        if (this.panel.l1 || this.panel.l2) {
          this.lenghtHasFinish = true
        } else {
          this.lenghtHasFinish = false
        }
        if (this.panel.b1 || this.panel.b2) {
          this.widthHasFinish = true
        } else {
          this.widthHasFinish = false
        }
      },
      getSelectedFinish(el) {
        let panel = this.panel
        let selectedFinishes = ['l1', 'l2', 'b1', 'b2'].filter(function(item) {
          return panel[item] === true
        })
        // If selected, return the element
        if (selectedFinishes.includes(el)) {
          return el
        }
        // Else, return the first selected element
        return selectedFinishes[0]
      },
      isValid() {
        if (this.panel.length === null || this.panel.width === null || this.panel.amount === null) {
          this.panel.valid = null
        } else {
          this.panel.valid = this.widthInvalid === false && this.lengthInvalid === false && this.amountInvalid === false && this.finishField === false
        }
      }
    },
    created() {
      EventBus.$on('validate-row', data => {
        this.validateRow()
      })
    },
    mounted() {
      if (this.panel.length) {
        this.length = this.panel.length
      }
      if (this.panel.width) {
        this.width = this.panel.width
      }
      if (this.panel.amount) {
        this.amount = this.panel.amount
      }
      this.setHasFinish(this.panel)
      this.validateRow()
    }
  }
</script>

<style lang="scss" scoped>
  .btn-danger {
    margin-left: 5px;
  }

  .form-control {
    padding: 0px;

    &.reference {
      padding: 3px;
    }
  }
</style>
